import React from 'react'

export default function CardDefault(props) {
  const {
    className="",
    isClickable=true,
    padding="p-1 md:p-0",
    children
  } = props

  const clickableClasses = "hover:bg-neutral-50 cursor-pointer transition duration-300 ease-in-out"
  return (
    <div 
      className={`${className} ${padding} ${isClickable ? clickableClasses : ''}`} 
      // radius={radius} 
      // shadow={shadow}
      // {...props} 
    >
      {children}
    </div>
  )
}
